<!-- UltraSimpleMultipleChatsIcon.vue -->
<template>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      :width="size"
      :height="size"
      :class="classes"
    >
      <!-- Two minimal chat bubbles -->

      <!-- Background chat bubble -->
      <rect
        x="3" y="6" width="12" height="10" rx="3"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        opacity="0.5"
      />

      <!-- Foreground chat bubble -->
      <rect
        x="8" y="8" width="12" height="10" rx="3"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
      />

      <!-- Simple chat lines -->
      <path
        d="M11 11h6M11 14h4"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  </template>

  <script>
  export default {
    name: 'UltraSimpleMultipleChatsIcon',
    props: {
      size: {
        type: [Number, String],
        default: 24
      },
      classes: {
        type: [String, Object, Array],
        default: ''
      }
    }
  }
  </script>
